import { appendCurrentChannelId } from '@/store/channel'
import pagesConfig from '@/pages.json'
import { isMpWeixin } from './platform'
import { LDBridge } from '@/utils/handleBrdge'
const { pages, subPackages, tabBar = { list: [] } } = { ...pagesConfig }

export const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包会报错，所以改用下面这个【虽然我加了 src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/** 判断当前页面是否是 tabbar 页  */
export const getIsTabbar = () => {
  try {
    const lastPage = getLastPage()
    const currPath = lastPage?.route

    return Boolean(tabBar?.list?.some((item) => item.pagePath === currPath))
  } catch {
    return false
  }
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 '/pages/login/index'
 * redirectPath 如 '/pages/demo/base/route-interceptor'
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // console.log(fullPath)
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

export const getUrlObj = (url: string) => {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}




/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages: string[] = getAllPages('needLogin').map((page) => page.path)

/**
 * 根据微信小程序当前环境，判断应该获取的 baseUrl
 */
export const getEnvBaseUrl = () => {
  // 请求基准地址
  let baseUrl = import.meta.env.VITE_SERVER_BASEURL

  // 微信小程序端环境区分
  // if (isMpWeixin) {
  //   const {
  //     miniProgram: { envVersion },
  //   } = uni.getAccountInfoSync()

  //   switch (envVersion) {
  //     case 'develop':
  //       baseUrl = import.meta.env.VITE_SERVER_BASEURL__WEIXIN_DEVELOP || baseUrl
  //       break
  //     case 'trial':
  //       baseUrl = import.meta.env.VITE_SERVER_BASEURL__WEIXIN_TRIAL || baseUrl
  //       break
  //     case 'release':
  //       baseUrl = import.meta.env.VITE_SERVER_BASEURL__WEIXIN_RELEASE || baseUrl
  //       break
  //   }
  // }

  return baseUrl
}

/**
 * 根据微信小程序当前环境，判断应该获取的 UPLOAD_BASEURL
 */
export const getEnvBaseUploadUrl = () => {
  // 请求基准地址
  let baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL

  // 微信小程序端环境区分
  if (isMpWeixin) {
    const {
      miniProgram: { envVersion },
    } = uni.getAccountInfoSync()

    switch (envVersion) {
      case 'develop':
        baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL__WEIXIN_DEVELOP || baseUploadUrl
        break
      case 'trial':
        baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL__WEIXIN_TRIAL || baseUploadUrl
        break
      case 'release':
        baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL__WEIXIN_RELEASE || baseUploadUrl
        break
    }
  }

  return baseUploadUrl
}

// 处理金额
export const getPriceText = (count: number) => {
  if (!count) return 0
  if (count <= 9999) {
    return count.toString()
  } else {
    return `${(count / 10000).toFixed(2)}w`
  }
}
/**
 * 根据点赞数量显示不同的文案
 * @param count 点赞数量
 * @param is 是否显示全部数值
 *  * <= 9999 显示真是数据
 * <= 100000 显示x.x万
 * > 100000 显示10万+
 */
export const getLikeCountText = (count: number, is: boolean) => {
  if (!count) return 0
  if (count <= 9999) {
    return count.toString()
  } else if (is || count <= 100000) {
    return `${(count / 10000).toFixed(1)}万`
  } else {
    return '10万+'
  }
}

/** 將數量格式化為完整數字、k 或 w。 */
export function formatCount(value?: number | string | null) {
  const count = Number(value)
  if (!Number.isFinite(count) || count <= 0)
    return '0'

  if (count < 1000)
    return String(count)

  const [divisor, suffix] = count >= 100000 ? [10000, 'w'] : [1000, 'k']
  const rounded = Math.round(count / divisor * 10) / 10
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}${suffix}`
}

// 根据经纬度 计算当前位置的距离
export function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371 // 地球半径（公里）
  const toRad = (value) => (value * Math.PI) / 180

  const phi1 = toRad(lat1)
  const phi2 = toRad(lat2)
  const deltaPhi = toRad(lat2 - lat1)
  const deltaLambda = toRad(lon2 - lon1)

  const a =
    Math.sin(deltaPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance = R * c

  return distance // 单位：公里
}

// 向RN发送消息的方法
function postToRN(message) {
  if (typeof window === 'undefined')
    return false
  const rnWindow = window as Window & {
    ReactNativeWebView?: { postMessage: (message: string) => void }
  }
  if (typeof rnWindow.ReactNativeWebView?.postMessage !== 'function')
    return false

  try {
    // 必须将对象转换为 JSON 字符串
    rnWindow.ReactNativeWebView.postMessage(JSON.stringify(message))
    return true
  } catch (err) {
    console.error('发送消息给 RN 失败:', err);
    return false
  }
}

/**
 * 通用返回方法：如果当前是最后一页则关闭webView，否则返回上一页
 * H5 单页且原生桥接不可用时，使用浏览器历史记录返回来源页
 */
export async function back() {
  const pages = getCurrentPages()
  if (pages.length === 1) {
    try {
      await LDBridge.closeWebview()
    } catch (error) {
      const handled = postToRN({
        type: 'close',   // 双方约定的消息类型
        payload: {
         // 业务数据
         action: 'back'
        }
      })
      // #ifdef H5
      if (!handled && typeof window !== 'undefined' && window.history.length > 1) {
        window.history.back()
      }
      // #endif
    }
  } else {
    // 页面栈大于1，正常返回
    uni.navigateBack()
  }
}

// 构建查询字符串的兼容函数
const buildQueryString = (params: any): string => {
  if (!params || typeof params !== 'object') return ''

  const queryParts: string[] = []
  for (const key in params) {
    if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null) {
      const value = encodeURIComponent(String(params[key]))
      queryParts.push(`${encodeURIComponent(key)}=${value}`)
    }
  }
  return queryParts.join('&')
}

export const routeTo = async (route: string, params: any) => {
  const queryString = buildQueryString(params)
  const url = appendCurrentChannelId(queryString ? `${route}?${queryString}` : route)

  // #ifdef H5
  const origin = location.origin
  try {
    await LDBridge.webView({
      urlString: `${origin}${url}`,
    })
  } catch (error) {
    console.error('newWebview error:', error)
    // 可以在这里添加降级处理，比如使用 uni.navigateTo
    console.log('fallback to uni.navigateTo')
    uni.navigateTo({ url })
  }
  // #endif

  // #ifdef MP-WEIXIN
  console.log('routeTo', route, params)
  uni.navigateTo({ url })
  // #endif
}

export const uploadFiles = async (files: Array<{ url: string }>) => {
  const result: any = []
  const token = uni.getStorageSync('token')
  for (const ele of files) {
    try {
      const uploadRes: any = await new Promise((resolve, reject) => {
        wx.uploadFile({
          url: getEnvBaseUrl() + '/nxcloud-app-user/c/app-c/v1/fileUploadApi/uploadFile',
          filePath: ele.url,
          name: 'file',
          header: { nxcloudToken: token },
          success: (res) => resolve(res),
          fail: (err) => reject(err),
        })
      })
      const fileData = JSON.parse(uploadRes.data)?.data
      const fData =
        fileData?.res?.suffix === 'mp4'
          ? {
              path: fileData?.relativePath,
              width: fileData?.width || 100,
              height: fileData?.height || 200,
              converImage: '',
              duration: 50,
              url: fileData?.url,
            }
          : {
              path: fileData?.relativePath,
              width: fileData?.width || 100,
              height: fileData?.height || 200,
              url: fileData?.url,
            }
      result.push(fData)
    } catch (err: any) {
      uni.showToast({ title: err?.errMsg || '请检查网络或配置', icon: 'none' })
      throw err
    }
  }
  return result
}

/**
 * 获取手机品牌
 * @returns 手机品牌名称
 */
export const getPhoneBrand = (): string => {
  const userAgent = navigator?.userAgent
  const userAgentStr = userAgent.toLowerCase()
  
  // iPhone 品牌
  if (userAgentStr.includes('iphone')) {
    return 'Apple'
  }
  
  // Android 品牌检测
  if (userAgentStr.includes('android')) {
    if (userAgentStr.includes('huawei')) {
      return 'Huawei'
    }
    if (userAgentStr.includes('honor')) {
      return 'HONOR'
    }
    if (userAgentStr.includes('xiaomi') || userAgentStr.includes('mi ') || userAgentStr.includes('redmi')) {
      return 'Xiaomi'
    }
    if (userAgentStr.includes('oppo')) {
      return 'OPPO'
    }
    if (userAgentStr.includes('vivo')) {
      return 'vivo'
    }
    return 'TengXun'
  }

  return 'TengXun'
}

/**
 * 颜色相关类型定义
 */
export interface ColorInfo {
  r: number
  g: number
  b: number
  a?: number
  hex: string
  rgb: string
  rgba?: string
  hsl?: string
}

export interface DominantColorResult {
  dominant: ColorInfo
  palette: ColorInfo[]
  average: ColorInfo
  rgba?: ColorInfo // 添加可選的 rgba 屬性
}

/**
 * 将RGB值转换为十六进制颜色
 * @param r 红色值 (0-255)
 * @param g 绿色值 (0-255)
 * @param b 蓝色值 (0-255)
 * @returns 十六进制颜色字符串
 */
export const rgbToHex = (r: number, g: number, b: number): string => {
  const toHex = (n: number) => {
    const hex = Math.round(Math.max(0, Math.min(255, n))).toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

/**
 * 将RGB值转换为HSL
 * @param r 红色值 (0-255)
 * @param g 绿色值 (0-255)
 * @param b 蓝色值 (0-255)
 * @returns HSL字符串
 */
export const rgbToHsl = (r: number, g: number, b: number): string => {
  r /= 255
  g /= 255
  b /= 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h = 0
  let s = 0
  const l = (max + min) / 2

  if (max !== min) {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h /= 6
  }

  return `hsl(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(l * 100)}%)`
}

/**
 * 创建颜色信息对象
 * @param r 红色值
 * @param g 绿色值
 * @param b 蓝色值
 * @param a 透明度值（可选）
 * @returns 颜色信息对象
 */
export const createColorInfo = (r: number, g: number, b: number, a?: number): ColorInfo => {
  const hex = rgbToHex(r, g, b)
  const rgb = `rgb(${r}, ${g}, ${b})`
  const rgba = a !== undefined ? `rgba(${r}, ${g}, ${b}, ${a})` : undefined
  const hsl = rgbToHsl(r, g, b)

  return {
    r,
    g,
    b,
    a,
    hex,
    rgb,
    rgba,
    hsl
  }
}

/**
 * 从图片URL获取主题色
 * @param imageUrl 图片URL
 * @param options 配置选项
 * @returns Promise<DominantColorResult>
 */
export const getImageThemeColor = async (
  imageUrl: string,
  options: {
    quality?: number // 采样质量，越小越快但精度越低，默认10
    colorCount?: number // 返回的主要颜色数量，默认8
    skipTransparent?: boolean // 是否跳过透明像素，默认true
    opacity?: number // 透明度，默认1
  } = {}
): Promise<DominantColorResult> => {
  const { quality = 10, colorCount = 8, skipTransparent = true, opacity = 1 } = options

  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        
        if (!ctx) {
          reject(new Error('无法创建canvas上下文'))
          return
        }

        // 设置canvas尺寸（根据质量参数缩放）
        const width = Math.floor(img.width / quality)
        const height = Math.floor(img.height / quality)
        canvas.width = width
        canvas.height = height

        // 绘制图片到canvas
        ctx.drawImage(img, 0, 0, width, height)

        // 获取像素数据
        const imageData = ctx.getImageData(0, 0, width, height)
        const pixels = imageData.data

        // 统计颜色
        const colorMap = new Map<string, { r: number; g: number; b: number; count: number }>()
        let totalR = 0
        let totalG = 0
        let totalB = 0
        let pixelCount = 0

        // 遍历像素
        for (let i = 0; i < pixels.length; i += 4) {
          const r = pixels[i]
          const g = pixels[i + 1]
          const b = pixels[i + 2]
          const a = pixels[i + 3]

          // 跳过透明像素
          if (skipTransparent && a < 128) continue

          const key = `${r},${g},${b}`
          if (colorMap.has(key)) {
            colorMap.get(key)!.count++
          } else {
            colorMap.set(key, { r, g, b, count: 1 })
          }

          totalR += r
          totalG += g
          totalB += b
          pixelCount++
        }

        // 计算平均颜色
        const averageColor = pixelCount > 0 
          ? createColorInfo(
              Math.round(totalR / pixelCount),
              Math.round(totalG / pixelCount),
              Math.round(totalB / pixelCount)
            )
          : createColorInfo(0, 0, 0)

        // 按出现频率排序并获取主要颜色
        const sortedColors = Array.from(colorMap.entries())
          .sort((a, b) => b[1].count - a[1].count)
          .slice(0, colorCount)

        const palette = sortedColors.map(([_, color]) => 
          createColorInfo(color.r, color.g, color.b)
        )

        const dominant = palette[0] || averageColor

        // 創建帶有指定透明度的 rgba 顏色
        const rgbaColor = pixelCount > 0 
          ? createColorInfo(
              Math.round(totalR / pixelCount),
              Math.round(totalG / pixelCount),
              Math.round(totalB / pixelCount),
              opacity
            )
          : createColorInfo(0, 0, 0, opacity)

        resolve({
          dominant,
          palette,
          average: averageColor,
          rgba: rgbaColor
        })
      } catch (error) {
        reject(error)
      }
    }

    img.onerror = () => {
      reject(new Error('图片加载失败'))
    }

    img.src = imageUrl
  })
}

export const isVersionLessThan = (version1, version2) => {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  // 比较两个版本号的每个部分
  const length = Math.max(v1Parts.length, v2Parts.length);
  for (let i = 0; i < length; i++) {
      const v1 = v1Parts[i] || 0;  // 如果没有对应部分，视为 0
      const v2 = v2Parts[i] || 0;

      if (v1 < v2) return true;  // 如果 v1 小于 v2，返回 true
      if (v1 > v2) return false; // 如果 v1 大于 v2，返回 false
  }
  return false;  // 如果两个版本号完全相等，返回 false
}



import type { PageMetaDatum, SubPackages } from '@uni-helper/vite-plugin-uni-pages'

export type PageInstance = Page.PageInstance<AnyObject, object> & { $page: Page.PageInstance<AnyObject, object> & { fullPath: string } }




export function ensureDecodeURIComponent(url: string) {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/login?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/login, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export function parseUrlToObj(url: string) {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 这里设计得通用一点，可以传递 key 作为判断依据，默认是 excludeLoginPath, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的 pages，如果传递了 key, 则表示通过 key 过滤
 */
export function getAllPages(key?: string) {
  // 这里处理主包
  const mainPages = (pages as PageMetaDatum[])
    .filter(page => !key || page[key])
    .map(page => ({
      ...page,
      path: `/${page.path}`,
    }))

  // 这里处理分包
  const subPages: PageMetaDatum[] = []
  ;(subPackages as SubPackages).forEach((subPageObj) => {
    // console.log(subPageObj)
    const { root } = subPageObj

    subPageObj.pages
      .filter(page => !key || page[key])
      .forEach((page) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  // console.log(`getAllPages by ${key} result: `, result)
  return result
}

export function getCurrentPageI18nKey() {
  const routeObj = currRoute()
  const currPage = (pages as PageMetaDatum[]).find(page => `/${page.path}` === routeObj.path)
  if (!currPage) {
    console.warn('路由不正确')
    return ''
  }
  console.log(currPage)
  console.log(currPage.style.navigationBarTitleText)
  return currPage.style?.navigationBarTitleText || ''
}



/**
 * 是否是双token模式
 */
export const isDoubleTokenMode = import.meta.env.VITE_AUTH_MODE === 'double'

/**
 * 首页路径，通过 page.json 里面的 type 为 home 的页面获取，如果没有，则默认是第一个页面
 * 通常为 /pages/index/index
 */
export const HOME_PAGE = `/${(pages as PageMetaDatum[]).find(page => page.type === 'home')?.path || (pages as PageMetaDatum[])[0].path}`

// ============ 推广指纹码管理 ============
// 注意：initFingerprint、retryPageView 请直接从 '@/utils/fingerprint' 导入
// 避免循环依赖问题（fingerprint.ts 依赖 index.ts 中的 getLastPage/currRoute）
